import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0] || ""}: ${String(x.msg).replace("Value error, ", "")}`).join("; ");
  return d || e?.message || "Something went wrong";
};

export const inr = (paise) =>
  "₹" + (Number(paise || 0) / 100).toLocaleString("en-IN", { minimumFractionDigits: paise % 100 ? 2 : 0, maximumFractionDigits: 2 });

export const rupees = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export const imgUrl = (u) => (!u ? "/images/detergent.jpg" : u.startsWith("/api") ? BACKEND_URL + u : u);

export const fmtDate = (iso, withTime = false) =>
  iso ? new Date(iso).toLocaleString("en-IN", withTime ? { dateStyle: "medium", timeStyle: "short" } : { dateStyle: "medium" }) : "—";

const key = (kind) => `bmi_tokens_${kind}`;
export const tokens = {
  get: (kind, id) => JSON.parse(localStorage.getItem(key(kind)) || "{}")[id],
  set: (kind, id, t) => {
    const m = JSON.parse(localStorage.getItem(key(kind)) || "{}");
    m[id] = t;
    localStorage.setItem(key(kind), JSON.stringify(m));
  },
};
export const tokenHeaders = (kind, id) => ({ "X-Access-Token": tokens.get(kind, id) || "" });

export const downloadText = (filename, text) => {
  const url = URL.createObjectURL(new Blob([text], { type: "text/plain" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const STATUS_LABEL = {
  draft: "Draft", payment_pending: "Payment Pending", submitted: "Submitted", under_review: "Under Review",
  shortlisted: "Shortlisted", interview_scheduled: "Interview Scheduled", selected: "Selected", rejected: "Rejected",
  withdrawn: "Withdrawn", awaiting_payment: "Awaiting Payment", payment_verification_pending: "Payment Verification Pending",
  paid: "Paid", processing: "Processing", packed: "Packed", shipped: "Shipped", delivered: "Delivered",
  cancelled: "Cancelled", refund_pending: "Refund Pending", refunded: "Refunded", unpaid: "Unpaid", pending: "Pending",
  failed: "Failed", created: "Created",
};
